import { render, staticRenderFns } from "./LinkMore.vue?vue&type=template&id=d40bcfa2&scoped=true&"
import script from "./LinkMore.vue?vue&type=script&lang=js&"
export * from "./LinkMore.vue?vue&type=script&lang=js&"
import style0 from "./LinkMore.vue?vue&type=style&index=0&id=d40bcfa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40bcfa2",
  null
  
)

export default component.exports